
import { Share, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { useResponsiveComponent } from '@/hooks/useResponsiveComponent';
import { copyUrlToClipboard } from '@/utils/urlUtils';
import MobilePropertyHeader from '@/components/mobile/MobilePropertyHeader';

interface PropertyHeaderProps {
  title: string;
  rating: number;
  neighborhood?: {
    city: string;
    state: string;
    country: string;
    description: string;
    longDescription: string;
  };
  guests?: number;
  bedrooms?: number;
  bathrooms?: number;
}

const PropertyHeader = ({ title, rating, neighborhood, guests, bedrooms, bathrooms }: PropertyHeaderProps) => {
  const { toast } = useToast();
  const { showMobileVersion } = useResponsiveComponent();

  const handleShare = async () => {
    const success = await copyUrlToClipboard();
    toast({
      description: success ? "Se copió el enlace" : "Error al copiar el enlace",
      variant: success ? "default" : "destructive",
    });
  };

  // Format location from neighborhood data
  const locationDisplay = neighborhood ? `${neighborhood.city}, ${neighborhood.state}` : '';

  return (
    <section className="py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-start justify-between">
          {showMobileVersion && guests && bedrooms && bathrooms ? (
            <MobilePropertyHeader
              title={title}
              rating={rating}
              location={locationDisplay}
              guests={guests}
              bedrooms={bedrooms}
              bathrooms={bathrooms}
            />
          ) : (
            <div className="flex-1">
              <h1 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
                {title}
              </h1>
              <div className="flex items-center space-x-4 text-sm mb-2">
                <div className="flex items-center space-x-1">
                  <Star className="w-4 h-4 fill-current text-gray-900" />
                  <span className="font-medium">{rating}</span>
                </div>
                <span className="text-gray-600 underline">{locationDisplay}</span>
              </div>
            </div>
          )}
          
          {!showMobileVersion && (
            <Button
              variant="outline"
              size="sm"
              onClick={handleShare}
              className="flex items-center space-x-2 ml-4"
            >
              <Share className="w-4 h-4" />
              <span>Compartir</span>
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default PropertyHeader;
